import React, { useEffect, useRef, useState, useMemo } from "react";
import { Tabs, Tab } from "@mui/material";
import PatientTemplate from "./components/PatientTemplate";
import PatientSummary from "./components/PatientSummary";
import PatientPreConsult from "./components/PatientPreConsult/PatientPreConsult";
import {
  setPatientTabSwitcher,
  setTogglePatientPanelTwo,
  setPatientSummary,
  setpatientSummaryLoader,
  setIsSummaryGenerated,
  setSecondPatientPanelTitle,
  addupdateConsultationSummary,
  setSelectedPatientConsultation,
  setIsSummaryStreaming,
  setReferralLetter,
  setDemDxSummary,
  trackServiceBilling,
  setTranscript,
  setPatientTranscription,
  setSnomedCodes,
  setShowPathwayCompletionModal,
} from "../../../../dispatchers/patientDispatchers";
import { setStreamedText } from "../../../../dispatchers/templateDispatchers";
import useTitanApp from "../../../../hooks/useTitanApp";
import { motion } from "framer-motion";
import { LuPanelLeftOpen, LuPanelRightOpen } from "react-icons/lu";
import NotesPanel from "../NotesPanel";
import { RefreshCw } from "lucide-react";
import FileEditPopover from "./components/FileEditPopover";
import DropdownMenu from "./components/DropdownMenu";
import FeedbackButton from "./components/FeedbackButton";
import AiStreamResponse from "../../../../utils/AiStreamResponse";
import { generateSummaryUrl } from "../../../../apiUrls/apiUrls";
import { FaCircle } from "react-icons/fa";
import { ConsultationButtonStatus } from "../../../../enum/ConsultationButtonStatus";
import { setConsultationLoadError } from "../../../../dispatchers/appDispatchers";
import {
  Popover,
  PopoverContent,
  PopoverTrigger,
} from "@/components/ui/popover";
import { Label } from "@/components/ui/label";
import { Filter } from "lucide-react";
import { Checkbox } from "@/components/ui/checkbox";
import { Button } from "@/components/ui/button";
import { trackFirstTimeIntercomEvent } from "@/utils/trackFirstTimeIntercomEvent";
import { NHS111EmergencySupplySummary } from "../../../nhs-templates/NHS111EmergencySupplySummary";
import { NHSContraceptionSummary } from "../../../nhs-templates/NHSContraceptionSummary";
import {
  nhs111TemplateId,
  nhsContraceptionTemplateId,
  nhsSinusitisTemplateId,
  nhsUtiTemplateId,
  nhsSoreThroatTemplateId,
  nhsImpetigoTemplateId,
  nhsInsectBitesTemplateId,
  nhsShinglesTemplateId,
  nhsAomTemplateId,
  nhsHypertensionStage1TemplateId,
  nhsHypertensionABPMFittingTemplateId,
  nhsHypertensionABPMFollowupTemplateId,
  nhsAhtWeightTemplateId,
  nhsAhtFollowUpTemplateId,
  nhsAhtSixMonthTemplateId,
  nhsAhtTravelHealthTemplateId,
} from "@/data/constantStrings";
import { ConsultationSummary } from "@/components/pharmacy-first";
import { getPathway } from "@/lib/pharmacyFirst";
import { NHSHypertensionInitialSummary } from "@/components/nhs-templates/NHSHypertensionInitialSummary";
import { TravelHealthConsultationSummary } from "@/components/travel-health/TravelHealthConsultationSummary";
import { NHS111ReferralTab } from "./components/NHS111ReferralTab";
import { NHSHypertensionABPMFittingSummary } from "@/components/nhs-templates/NHSHypertensionABPMFittingSummary";
import {
  isNhsService,
  getNhsServiceName,
} from "@/components/nhs-templates/NHSServicesHelper";
import { NHSHypertensionABPMFollowUpSummary } from "@/components/nhs-templates/NHSHypertensionABPMFollowUpSummary";
import { PGDWeightManagementSummary } from "@/components/nhs-templates/PGDWeightManagementSummary";
import { buildAhtWeightSummaryData } from "@/components/nhs-templates/ahtWeightSummaryData";

export default function PatientTemplateDEMDx({
  stopTranscription,
  isDemDXGlobalCheckRef,
}) {
  const {
    appState,
    patientState,
    templateState,
    pharmacyServiceState,
  } = useTitanApp();

  const { darkMode, currentPharmacyId, companyId, currentUser } =
    appState || {};
  const { features } = appState || {};
  const { ifSnomedCodesEnabled } = features || {};
  const { selectedTemplate, streamedText, isTemplateSelected } =
    templateState || {};
  const {
    patientTabSwitcher,
    togglePatientPanelOne,
    togglePatientPanelTwo,
    secondPatientPanelTitle,
    isSummaryStreaming,
    demDXForChat,
    isSummaryEnabled,
    selectedPatientConsultation,
    isFinalSummary,
    PatientNotes,
    patientSummary,
    consultationId,
    isNotesExpanded,
    transcript,
    preConsultAddtoSummary,
    preConsultationTranscription,
    isSummaryGenerated,
    isCallStarted,
    consultationMediaButtonMode,
    isHandleStartConsultation,
    preConsultationTemplate,
    snomedCodes = [],
    nhs111FormData,
    nhs111Prescriptions,
    nhs111EmergencySupplyMedications,
    consultationServiceCode,
    isManualSubmited,
    hasPreConsultTab,
    nhsContraceptionFormData,
    nhsSinusitisFormData,
    nhsUtiFormData,
    nhsSoreThroatFormData,
    nhsImpetigoFormData,
    nhsInsectBitesFormData,
    nhsShinglesFormData,
    nhsAomFormData,
    nhsAhtFormData,
    hypertensionInitialFormData,
    hypertensionABPMFittingFormData,
    hypertensionABPMFollowupFormData,
  } = patientState || {};
  const { showNHS111ReferralTab } = pharmacyServiceState || {};
  const [notesHeight, setNotesHeight] = useState(150);
  const [summaryOptions, setSummaryOptions] = useState({
    includeVitals: true,
    includeActions: true,
  });
  const [highlightedSnomedEvidence, setHighlightedSnomedEvidence] = useState(
    null,
  );

  const accumulatedText = useRef("");
  const shownKeys = useRef(new Set());
  const queue = useRef([]);
  const typingInterval = useRef(null);
  const buffer = useRef("");
  const serviceSummary =
    selectedTemplate?.consultationSummary ??
    selectedPatientConsultation?.template?.consultationSummary;

  const summaryEffectiveTemplateId = useMemo(() => {
    const tid = selectedPatientConsultation?.templateId;
    if (tid) return tid;

    const sentinel = selectedPatientConsultation?.template?.templateSections?.find(
      (s) => s.sectionTitle === "__pathway_engine_metadata__",
    );
    if (sentinel) {
      const pid = sentinel.userControls?.find((c) => c.label === "pathwayId")
        ?.value;
      if (pid) {
        if (pid.startsWith("aht-")) return nhsAhtWeightTemplateId;
        const map = {
          sinusitis: nhsSinusitisTemplateId,
          uti: nhsUtiTemplateId,
          sorethroat: nhsSoreThroatTemplateId,
          impetigo: nhsImpetigoTemplateId,
          insectbites: nhsInsectBitesTemplateId,
          shingles: nhsShinglesTemplateId,
          otitismedia: nhsAomTemplateId,
        };
        if (map[pid]) return map[pid];
      }
    }

    try {
      const raw = selectedPatientConsultation?.consultationSummary;
      if (raw) {
        let parsed = JSON.parse(raw);
        if (typeof parsed === "string") parsed = JSON.parse(parsed);
        if (parsed?._type === "travel-health-consultation")
          return nhsAhtTravelHealthTemplateId;
        if (parsed?.pathwayId) {
          if (parsed.pathwayId.startsWith("aht-"))
            return nhsAhtWeightTemplateId;
          const map = {
            sinusitis: nhsSinusitisTemplateId,
            uti: nhsUtiTemplateId,
            sorethroat: nhsSoreThroatTemplateId,
            impetigo: nhsImpetigoTemplateId,
            insectbites: nhsInsectBitesTemplateId,
            shingles: nhsShinglesTemplateId,
            otitismedia: nhsAomTemplateId,
          };
          if (map[parsed.pathwayId]) return map[parsed.pathwayId];
        }
      }
    } catch {}

    return null;
  }, [
    selectedPatientConsultation?.templateId,
    selectedPatientConsultation?.template,
    selectedPatientConsultation?.consultationSummary,
  ]);

  // The AHT weight PGD drives its own notes through the pathway engine, so the
  // shared "Extra notes" panel is suppressed for it — and strictly for it. Match
  // the live template id only (not summaryEffectiveTemplateId, whose "aht-"
  // fallback also covers the follow-up and six-month reviews).
  const isAhtWeightTemplate =
    selectedTemplate?._id === nhsAhtWeightTemplateId ||
    selectedPatientConsultation?.templateId === nhsAhtWeightTemplateId;

  const params = {
    transcription: transcript,
    serviceSummary,
    isFinalSummary,
    notes: PatientNotes,
    preConsultTranscription: preConsultAddtoSummary
      ? selectedPatientConsultation?.preConsultationTemplate
        ? preConsultationTranscription
        : ""
      : "",
    // includeActions: true,
    // includeVitals: true, <---- for next release
    // ConsultationId:consultationId,
  };
  const extractNewTextIncremental = (buffer, shownKeys) => {
    const regex = /"([^"]+)":\s*"([^"]*)"/g;
    let match;
    let output = "";
    let lastIndex = 0;
    while ((match = regex.exec(buffer)) !== null) {
      const key = match[1];
      const value = match[2];
      if (key === "Actions") continue;
      if (!shownKeys.has(key)) {
        output += `${key}: ${value}\n\n`;
        shownKeys.add(key);
      }
      lastIndex = regex.lastIndex;
    }
    return {
      text: output,
      remainingBuffer: buffer.slice(lastIndex),
    };
  };
  const startTypingEffect = () => {
    if (typingInterval.current) return;
    typingInterval.current = setInterval(() => {
      if (queue.current.length > 0) {
        const nextChar = queue.current.shift();
        setStreamedText((prev) => {
          const updated = prev + nextChar;
          return updated;
        });
      } else {
        clearInterval(typingInterval.current);
        typingInterval.current = null;
      }
    }, 15);
  };
  const isGeneratingRef = useRef(false);
  const previousSummaryOptionsRef = useRef(summaryOptions);

  function generateTranscription(selectedPatientConsultation) {
    if (
      !selectedPatientConsultation ||
      !Array.isArray(selectedPatientConsultation?.templateSections)
    ) {
      return "";
    }

    let transcription = "";

    selectedPatientConsultation?.templateSections.forEach((section) => {
      if (Array.isArray(section?.userControls)) {
        section.userControls.forEach((control) => {
          if (control?.label && control?.value) {
            transcription += `${control.label}: ${control.value}\n`;
          }
        });
      }
    });

    const finalText = transcription.trim();

    setTranscript(finalText);
    setPatientTranscription(finalText);

    return finalText;
  }

  const getData = async () => {
    try {
      setIsSummaryStreaming(true);
      setpatientSummaryLoader(true);
      isGeneratingRef.current = true;
      accumulatedText.current = "";
      shownKeys.current = new Set();
      setStreamedText("");
      queue.current = [];
      const isTranscriptEmpty = !transcript || transcript.trim() === "";

      const params = {
        transcription:
          isManualSubmited && isTranscriptEmpty && preConsultationTranscription
            ? preConsultationTranscription
            : transcript && transcript.trim() !== ""
            ? transcript
            : generateTranscription(selectedPatientConsultation?.template),

        serviceSummary,
        isFinalSummary,
        notes: PatientNotes,
        preConsultTranscription: preConsultAddtoSummary
          ? selectedPatientConsultation?.preConsultationTemplate
            ? preConsultationTranscription
            : ""
          : "",
        includeActions: summaryOptions.includeActions,
        includeVitals: summaryOptions.includeVitals,
        ConsultationId: consultationId,
        includeSnomedCodes: ifSnomedCodesEnabled,
      };

      return await AiStreamResponse(
        params,
        (chunk) => {
          accumulatedText.current += chunk;
          buffer.current += chunk;
          const { text: newText, remainingBuffer } = extractNewTextIncremental(
            buffer.current,
            shownKeys.current,
          );
          if (newText) {
            queue.current.push(...newText);
            startTypingEffect();
          }
          buffer.current = remainingBuffer;
        },
        async () => {
          setpatientSummaryLoader(false);
          clearInterval(typingInterval.current);
          typingInterval.current = null;
          let isJson = false;
          let finalFormattedText = "";
          let finalSnomedCodes = null;
          // Strip markdown code fences (e.g. ```json ... ```) that the AI sometimes returns
          accumulatedText.current = accumulatedText.current
            .replace(/^```(?:json)?\s*/i, "")
            .replace(/\s*```\s*$/, "")
            .trim();
          const tryFixJson = (str) => {
            let fixed = str;
            const missingCommaRegex = /("[^"]*")\s*"([^"]+)":\s*(\[|"|[0-9]|true|false|null)/g;
            fixed = fixed.replace(missingCommaRegex, '$1,\n"$2": $3');

            const beforeActionsRegex = /("[^"]*")\s*"Actions"\s*:\s*\[/g;
            fixed = fixed.replace(beforeActionsRegex, '$1,\n"Actions": [');

            return fixed;
          };
          try {
            JSON.parse(accumulatedText.current);
            isJson = true;
          } catch (e) {
            try {
              const fixedJson = tryFixJson(accumulatedText.current);
              JSON.parse(fixedJson);
              accumulatedText.current = fixedJson;
              isJson = true;
            } catch (e2) {
              isJson = false;
            }
          }
          try {
            JSON.parse(accumulatedText.current);
            isJson = true;
          } catch (e) {
            isJson = false;
          }
          if (isJson) {
            try {
              const finalParsed = JSON.parse(accumulatedText.current);
              const responseSnomedCodes =
                finalParsed?.snomedCodes ?? finalParsed?.SnomedCodes;
              setSnomedCodes(
                Array.isArray(responseSnomedCodes) ? responseSnomedCodes : [],
              );

              finalFormattedText = Object.entries(finalParsed)
                .filter(
                  ([key]) =>
                    key !== "Actions" &&
                    key !== "snomedCodes" &&
                    key !== "SnomedCodes",
                )
                .map(([key, value]) => `${key}:\n${value}`)
                .join("\n\n");
              finalSnomedCodes = responseSnomedCodes;
              setPatientSummary({
                ...finalParsed,
                SummaryText: finalFormattedText,
              });
              setStreamedText(finalFormattedText);
            } catch (err) {
              console.error("Failed to parse JSON response:", err);
              setSnomedCodes([]);
              finalFormattedText = accumulatedText.current;
              setStreamedText(accumulatedText.current);
            }
          } else {
            setSnomedCodes([]);
            finalFormattedText = accumulatedText.current;
            setStreamedText(accumulatedText.current);
          }

          if (finalFormattedText) {
            try {
              await addupdateConsultationSummary({
                consultationId,
                summary:
                  finalFormattedText +
                  " SnomedCodes: " +
                  JSON.stringify(finalSnomedCodes),
              });
              try {
                trackServiceBilling({
                  companyId,
                  consultationId,
                  pharmacyId: currentPharmacyId,
                  actiontype: "aicall-summary",
                });
              } catch (err) {
                console.error(
                  "Error calling trackServiceBilling (summary):",
                  err,
                );
              }

              trackFirstTimeIntercomEvent({
                eventName: "ai_summary_generated_first_time",
                user: {
                  id: currentUser.emailAddress,
                  email: currentUser.emailAddress,
                  name: currentUser.fullName,
                },
                properties: {
                  source: "demdx_template",
                },
              });
            } catch (error) {
              console.error("Failed to update consultation summary:", error);
            }
          }
          setIsSummaryStreaming(false);
          setpatientSummaryLoader(false);
          isGeneratingRef.current = false;
        },
        generateSummaryUrl(),
      ).finally(() => {
        setpatientSummaryLoader(false);
        setIsSummaryStreaming(false);
        isGeneratingRef.current = false;
      });
    } catch (networkError) {
      console.error(
        "Network or API error while fetching AI response:",
        networkError,
      );
      setConsultationLoadError(true);
      setIsSummaryStreaming(false);
      setpatientSummaryLoader(false);
      isGeneratingRef.current = false;
    }
  };

  const handleRegenerate = async () => {
    if (selectedPatientConsultation?.consultationStatus === 1) return;
    const hasTranscriptionSource =
      transcript?.trim() ||
      preConsultationTranscription?.trim() ||
      selectedPatientConsultation?.template;

    if (hasTranscriptionSource && serviceSummary !== "") {
      // setSelectedPatientConsultation(null);
      setReferralLetter("");
      setPatientSummary("");
      await getData();
      setIsSummaryGenerated(true);
    } else if (patientSummary) {
      if (typeof patientSummary === "object") {
        if (patientSummary.SummaryText) {
          setStreamedText(patientSummary.SummaryText);
        } else {
          const summaryText = Object.entries(patientSummary)
            .filter(
              ([k]) =>
                k !== "Actions" &&
                k !== "SummaryText" &&
                k !== "snomedCodes" &&
                k !== "SnomedCodes",
            )
            .map(([k, v]) => `${k}: \n${v}`)
            .join("\n\n");
          setStreamedText(summaryText);
        }
      }
    }
  };

  useEffect(() => {
    const previousSummaryOptions = previousSummaryOptionsRef.current;
    const hasSummaryOptionChanged =
      previousSummaryOptions.includeActions !== summaryOptions.includeActions ||
      previousSummaryOptions.includeVitals !== summaryOptions.includeVitals;

    previousSummaryOptionsRef.current = summaryOptions;

    if (
      !hasSummaryOptionChanged ||
      !isSummaryGenerated ||
      isSummaryStreaming ||
      isGeneratingRef.current
    ) {
      return;
    }

    handleRegenerate();
  }, [summaryOptions.includeActions, summaryOptions.includeVitals]);

  const handleChange = (event, newValue) => {
    if (isSummaryStreaming) return;
    if (patientTabSwitcher !== newValue) {
      setPatientTabSwitcher(newValue);
    }
  };

  const collapsePanel = () => {
    setTogglePatientPanelTwo(true);
    setSecondPatientPanelTitle("Summary");
  };
  const isConsultationCompleted =
    selectedPatientConsultation?.consultationButtonStatus ===
    ConsultationButtonStatus.Completed;

  let isSummaryTabDisabled;
  if (
    isNhsService(selectedPatientConsultation?.templateId) ||
    isNhsService(summaryEffectiveTemplateId)
  ) {
    const hasSummary =
      (selectedPatientConsultation?.consultationSummary?.length ?? 0) > 0;
    isSummaryTabDisabled = !hasSummary;
  } else {
    if (isHandleStartConsultation) {
      isSummaryTabDisabled =
        !isSummaryGenerated ||
        demDXForChat ||
        isSummaryStreaming ||
        isCallStarted;
    } else {
      isSummaryTabDisabled =
        isSummaryStreaming ||
        isCallStarted ||
        selectedPatientConsultation?.consultationButtonStatus === 1 ||
        selectedPatientConsultation?.consultationButtonStatus === 4;
    }
  }

  const showPreConsult = hasPreConsultTab;

  const normalizeCodeValue = (value) => String(value || "").trim();

  const handleDeleteSnomedCode = (codeToDelete) => {
    const targetCode = normalizeCodeValue(codeToDelete?.code);
    const targetEvidence = String(codeToDelete?.evidence || "").trim();

    const updatedCodes = (Array.isArray(snomedCodes) ? snomedCodes : []).filter(
      (item) => {
        const itemCode = normalizeCodeValue(item?.code);
        const itemEvidence = String(item?.evidence || "").trim();
        return !(itemCode === targetCode && itemEvidence === targetEvidence);
      },
    );

    setSnomedCodes(updatedCodes);

    if (highlightedSnomedEvidence === codeToDelete?.evidence) {
      setHighlightedSnomedEvidence(null);
    }
  };

  return (
    <motion.div
      className="pc-sections"
      animate={{
        width: togglePatientPanelTwo
          ? "3%"
          : togglePatientPanelOne
          ? "48.5%"
          : "33.33%",
      }}
      transition={{ duration: 0.5, type: "spring", stiffness: 60 }}
    >
      {togglePatientPanelTwo && (
        <motion.div
          className="collapsed-wrapper"
          key="collapsed-one"
          initial={{ y: -13, opacity: 0 }}
          animate={{ y: 0, opacity: 1 }}
          exit={{ y: -13, opacity: 0 }}
          transition={{ duration: 0.4, delay: 0.6 }}
        >
          <LuPanelLeftOpen
            className="collapse-icon"
            color={darkMode ? "#fff" : "#0a0a0a"}
            onClick={() => setTogglePatientPanelTwo(false)}
          />
          <p
            className="collapsed-title"
            style={{
              marginTop:
                secondPatientPanelTitle === "Template" ||
                secondPatientPanelTitle === "Summary"
                  ? "10px"
                  : "0",
            }}
          >
            {secondPatientPanelTitle || ""}
          </p>
        </motion.div>
      )}
      <motion.div
        animate={
          togglePatientPanelTwo ? { y: 30, opacity: 0 } : { y: 0, opacity: 1 }
        }
        transition={{
          duration: 0.4,
          delay: !togglePatientPanelTwo && 0.6,
        }}
        style={{ height: "100%", display: "flex", flexDirection: "column" }}
      >
        {!togglePatientPanelTwo && (
          <>
            <Tabs
              value={patientTabSwitcher}
              onChange={handleChange}
              aria-label="Tabs"
              variant="fullWidth"
            >
              {showPreConsult && (
                <Tab
                  label={
                    <span className="flex items-center gap-2 tabs_text">
                      Pre Consult <FaCircle color="#14c468" size={8} />
                    </span>
                  }
                />
              )}
              {showNHS111ReferralTab && (
                <Tab label={<span className="tabs_text">Referral</span>} />
              )}
              <Tab label={<span className="tabs_text">Template</span>} />
              <Tab
                label={<span className="tabs_text">Summary</span>}
                disabled={isSummaryTabDisabled}
              />
            </Tabs>
            {patientTabSwitcher ===
              (showPreConsult || showNHS111ReferralTab ? 2 : 1) && (
              <div
                className={`panel-header ${
                  darkMode ? "panel-header--dark" : "panel-header--light"
                }`}
              >
                <div className="panel-actions">
                  <div className="panel-actions-container">
                    <LuPanelRightOpen
                      className="collapse-icon"
                      color={darkMode ? "#fff" : "#000"}
                      onClick={collapsePanel}
                    />
                    <button
                      onClick={handleRegenerate}
                      className="regen-btn"
                      disabled={isSummaryStreaming}
                    >
                      <RefreshCw
                        className={`refresh-icon ${
                          isSummaryStreaming ? "spin" : ""
                        }`}
                      />
                      Regenerate
                    </button>
                    <FileEditPopover isDarkMode={darkMode} />
                    <Popover>
                      <PopoverTrigger asChild>
                        <Button
                          size="sm"
                          variant="outline"
                          className={`h-8 w-8 p-0 ${
                            darkMode
                              ? "bg-gray-800 border-gray-600 text-white hover:bg-gray-700"
                              : "bg-white border-gray-300 hover:bg-gray-50"
                          }`}
                        >
                          <Filter className="w-3 h-3" />
                        </Button>
                      </PopoverTrigger>
                      <PopoverContent
                        className={`w-64 ${
                          darkMode ? "bg-gray-800 border-gray-600" : "bg-white"
                        }`}
                      >
                        <div className="space-y-4">
                          <h4
                            className={`font-medium text-sm ${
                              darkMode ? "text-white" : "text-gray-900"
                            }`}
                          >
                            Summary Options
                          </h4>
                          <div className="space-y-3">
                            <div className="flex items-center space-x-2">
                              <Checkbox
                                id="include-vitals"
                                checked={summaryOptions.includeVitals}
                                onCheckedChange={(checked) =>
                                  setSummaryOptions((prev) => ({
                                    ...prev,
                                    includeVitals: !!checked,
                                  }))
                                }
                              />
                              <Label
                                htmlFor="include-vitals"
                                className={`text-sm ${
                                  darkMode ? "text-gray-200" : "text-gray-700"
                                }`}
                              >
                                Include Vitals captured
                              </Label>
                            </div>
                            <div className="flex items-center space-x-2">
                              <Checkbox
                                id="include-actions"
                                checked={summaryOptions.includeActions}
                                onCheckedChange={(checked) =>
                                  setSummaryOptions((prev) => ({
                                    ...prev,
                                    includeActions: !!checked,
                                  }))
                                }
                              />
                              <Label
                                htmlFor="include-actions"
                                className={`text-sm ${
                                  darkMode ? "text-gray-200" : "text-gray-700"
                                }`}
                              >
                                Include Actions captured
                              </Label>
                            </div>
                          </div>
                        </div>
                      </PopoverContent>
                    </Popover>
                    <DropdownMenu
                      streamedText={streamedText}
                      setStreamedText={setStreamedText}
                      isDarkMode={darkMode}
                      isSummaryGenerating={isSummaryStreaming}
                    />
                  </div>
                </div>

                <div className="flex items-center gap-3">
                  <div className="flex items-center gap-2">
                    {ifSnomedCodesEnabled && snomedCodes.length > 0 && (
                      <Popover>
                        <PopoverTrigger asChild>
                          <button
                            className={`flex items-center gap-1.5 px-2 py-1 rounded-md text-xs font-medium transition-colors ${
                              darkMode
                                ? "bg-gray-800 text-gray-300 hover:bg-gray-700 border border-gray-700"
                                : "bg-white text-gray-600 hover:bg-gray-100 border border-gray-200"
                            }`}
                          >
                            <svg
                              className={`w-3 h-3 ${
                                darkMode ? "text-gray-400" : "text-gray-500"
                              }`}
                              viewBox="0 0 24 24"
                              fill="none"
                              stroke="currentColor"
                              strokeWidth="2"
                              strokeLinecap="round"
                              strokeLinejoin="round"
                            >
                              <path d="M14 2H6a2 2 0 0 0-2 2v16a2 2 0 0 0 2 2h12a2 2 0 0 0 2-2V8z" />
                              <polyline points="14 2 14 8 20 8" />
                              <line x1="16" y1="13" x2="8" y2="13" />
                              <line x1="16" y1="17" x2="8" y2="17" />
                              <polyline points="10 9 9 9 8 9" />
                            </svg>
                            {snomedCodes.length} SNOMED CT
                          </button>
                        </PopoverTrigger>
                        <PopoverContent
                          className={`w-96 ${
                            darkMode
                              ? "bg-gray-800 border-gray-600"
                              : "bg-white"
                          }`}
                          align="end"
                        >
                          <div className="space-y-1">
                            <h4
                              className={`text-xs font-semibold uppercase tracking-wide ${
                                darkMode ? "text-gray-400" : "text-gray-500"
                              }`}
                            >
                              SNOMED CT Codes ({snomedCodes.length})
                            </h4>
                            <div className="pt-1 space-y-3 overflow-y-auto max-h-72">
                              {["high", "medium", "low"].map((level) => {
                                const codes = (Array.isArray(snomedCodes)
                                  ? snomedCodes
                                  : []
                                ).filter((sc) => sc.relevance === level);
                                if (codes.length === 0) return null;
                                return (
                                  <div key={level}>
                                    <div
                                      className={`flex items-center gap-2 mb-1.5 ${
                                        level !== "high" ? "pt-1" : ""
                                      }`}
                                    >
                                      <div
                                        className={`h-px flex-1 ${
                                          darkMode
                                            ? "bg-gray-700"
                                            : "bg-gray-200"
                                        }`}
                                      />
                                      <span
                                        className={`text-[10px] font-semibold uppercase tracking-wider flex-shrink-0 ${
                                          darkMode
                                            ? "text-gray-500"
                                            : "text-gray-400"
                                        }`}
                                      >
                                        {level} relevance
                                      </span>
                                      <div
                                        className={`h-px flex-1 ${
                                          darkMode
                                            ? "bg-gray-700"
                                            : "bg-gray-200"
                                        }`}
                                      />
                                    </div>
                                    <div className="space-y-2">
                                      {codes.map((sc) => (
                                        <div
                                          key={sc.code}
                                          className={`group px-3 py-2.5 rounded-lg text-xs border transition-colors ${
                                            darkMode
                                              ? "bg-gray-700/40 border-gray-600/50 hover:bg-gray-700/70"
                                              : "bg-gray-50/80 border-gray-100 hover:bg-gray-100/80"
                                          }`}
                                        >
                                          <div className="flex items-center justify-between gap-2">
                                            <div className="flex items-center min-w-0 gap-2">
                                              <code
                                                className={`font-mono text-[11px] flex-shrink-0 px-1.5 py-0.5 rounded ${
                                                  darkMode
                                                    ? "text-blue-400 bg-blue-900/30"
                                                    : "text-blue-600 bg-blue-50"
                                                }`}
                                              >
                                                {sc.code}
                                              </code>
                                              <span
                                                className={`font-medium truncate ${
                                                  darkMode
                                                    ? "text-gray-200"
                                                    : "text-gray-700"
                                                }`}
                                              >
                                                {sc.display}
                                              </span>
                                            </div>
                                            <div className="flex items-center gap-0.5 flex-shrink-0">
                                              <button
                                                onClick={() => {
                                                  setHighlightedSnomedEvidence(
                                                    sc.evidence,
                                                  );
                                                  setTimeout(() => {
                                                    const el = document.querySelector(
                                                      "[data-snomed-highlight]",
                                                    );
                                                    if (el) {
                                                      el.scrollIntoView({
                                                        behavior: "smooth",
                                                        block: "center",
                                                      });
                                                    }
                                                  }, 50);
                                                }}
                                                className={`p-1 rounded-md transition-colors ${
                                                  darkMode
                                                    ? "text-gray-500 hover:text-blue-400 hover:bg-gray-600"
                                                    : "text-gray-400 hover:text-blue-600 hover:bg-blue-50"
                                                }`}
                                                title="Show in summary"
                                              >
                                                <svg
                                                  className="w-3.5 h-3.5"
                                                  viewBox="0 0 24 24"
                                                  fill="none"
                                                  stroke="currentColor"
                                                  strokeWidth="2"
                                                  strokeLinecap="round"
                                                  strokeLinejoin="round"
                                                >
                                                  <circle
                                                    cx="11"
                                                    cy="11"
                                                    r="8"
                                                  />
                                                  <line
                                                    x1="21"
                                                    y1="21"
                                                    x2="16.65"
                                                    y2="16.65"
                                                  />
                                                </svg>
                                              </button>
                                              <button
                                                onClick={() => {
                                                  handleDeleteSnomedCode(sc);
                                                }}
                                                className={`p-1 rounded-md transition-colors opacity-0 group-hover:opacity-100 ${
                                                  darkMode
                                                    ? "text-gray-500 hover:text-red-400 hover:bg-gray-600"
                                                    : "text-gray-400 hover:text-red-500 hover:bg-red-50"
                                                }`}
                                                title="Remove suggestion"
                                              >
                                                <svg
                                                  className="w-3.5 h-3.5"
                                                  viewBox="0 0 24 24"
                                                  fill="none"
                                                  stroke="currentColor"
                                                  strokeWidth="2"
                                                  strokeLinecap="round"
                                                  strokeLinejoin="round"
                                                >
                                                  <line
                                                    x1="18"
                                                    y1="6"
                                                    x2="6"
                                                    y2="18"
                                                  />
                                                  <line
                                                    x1="6"
                                                    y1="6"
                                                    x2="18"
                                                    y2="18"
                                                  />
                                                </svg>
                                              </button>
                                            </div>
                                          </div>
                                          <p
                                            className={`mt-1.5 italic text-[11px] leading-relaxed ${
                                              darkMode
                                                ? "text-gray-500"
                                                : "text-gray-400"
                                            }`}
                                          >
                                            "{sc.evidence}"
                                          </p>
                                        </div>
                                      ))}
                                    </div>
                                  </div>
                                );
                              })}
                            </div>
                          </div>
                        </PopoverContent>
                      </Popover>
                    )}
                  </div>
                  <FeedbackButton isDarkMode={darkMode} />
                </div>
              </div>
            )}
            <div
              className="template-notes-wrapper"
              style={{ flex: 1, minHeight: 0, height: "auto" }}
            >
              <div
                className={`content ${
                  patientTabSwitcher ===
                  (showPreConsult || showNHS111ReferralTab ? 1 : 0)
                    ? "notes-up"
                    : ""
                }`}
              >
                {showPreConsult && patientTabSwitcher === 0 && (
                  <PatientPreConsult />
                )}
                {showNHS111ReferralTab && patientTabSwitcher === 0 && (
                  <NHS111ReferralTab isDarkMode={darkMode} />
                )}
                {patientTabSwitcher ===
                  (showPreConsult || showNHS111ReferralTab ? 1 : 0) && (
                  <div className="split-pane">
                    <div
                      className="top-pane"
                      style={{
                        height: isAhtWeightTemplate
                          ? "100%"
                          : `calc(100% - ${notesHeight}px)`,
                      }}
                    >
                      <PatientTemplate
                        stopTranscription={stopTranscription}
                        isDemDXGlobalCheckRef={isDemDXGlobalCheckRef}
                      />
                    </div>
                    {!isAhtWeightTemplate && (
                      <div
                        className="bottom-pane"
                        style={{ height: `${notesHeight}px` }}
                      >
                        <NotesPanel onHeightChange={setNotesHeight} />
                      </div>
                    )}
                  </div>
                )}
                {patientTabSwitcher ===
                  (showPreConsult || showNHS111ReferralTab ? 2 : 1) &&
                  (summaryEffectiveTemplateId === nhs111TemplateId &&
                  nhs111FormData ? (
                    <NHS111EmergencySupplySummary
                      isDarkMode={darkMode}
                      data={nhs111FormData}
                      prescriptions={nhs111Prescriptions}
                      emergencySupplyMedications={
                        nhs111EmergencySupplyMedications
                      }
                      patientId={selectedPatientConsultation?.patientId}
                    />
                  ) : summaryEffectiveTemplateId ===
                      nhsHypertensionStage1TemplateId &&
                    hypertensionInitialFormData ? (
                    <NHSHypertensionInitialSummary
                      isDarkMode={darkMode}
                      data={hypertensionInitialFormData}
                    />
                  ) : summaryEffectiveTemplateId ===
                      nhsHypertensionABPMFittingTemplateId &&
                    hypertensionABPMFittingFormData ? (
                    <NHSHypertensionABPMFittingSummary
                      isDarkMode={darkMode}
                      data={hypertensionABPMFittingFormData}
                    />
                  ) : summaryEffectiveTemplateId ===
                      nhsHypertensionABPMFollowupTemplateId &&
                    hypertensionABPMFollowupFormData ? (
                    <NHSHypertensionABPMFollowUpSummary
                      isDarkMode={darkMode}
                      data={hypertensionABPMFollowupFormData}
                    />
                  ) : summaryEffectiveTemplateId ===
                      nhsContraceptionTemplateId && nhsContraceptionFormData ? (
                    <NHSContraceptionSummary
                      isDarkMode={darkMode}
                      data={nhsContraceptionFormData}
                    />
                  ) : summaryEffectiveTemplateId === nhsSinusitisTemplateId ? (
                    (() => {
                      const audit =
                        nhsSinusitisFormData ||
                        (() => {
                          try {
                            if (
                              !selectedPatientConsultation?.consultationSummary
                            )
                              return null;
                            let parsed = JSON.parse(
                              selectedPatientConsultation.consultationSummary,
                            );
                            if (typeof parsed === "string")
                              parsed = JSON.parse(parsed);
                            return parsed;
                          } catch {
                            return null;
                          }
                        })();
                      if (!audit || !audit.patient)
                        return (
                          <PatientSummary
                            getData={getData}
                            highlightedSnomedEvidence={
                              highlightedSnomedEvidence
                            }
                            darkMode={darkMode}
                          />
                        );
                      let pathway;
                      try {
                        pathway = getPathway("sinusitis");
                      } catch {
                        return null;
                      }
                      return (
                        <ConsultationSummary
                          audit={audit}
                          pathway={pathway}
                          isDarkMode={darkMode}
                          readOnly={isConsultationCompleted}
                          onClose={
                            isConsultationCompleted
                              ? undefined
                              : () => setShowPathwayCompletionModal(true)
                          }
                        />
                      );
                    })()
                  ) : summaryEffectiveTemplateId === nhsUtiTemplateId ? (
                    (() => {
                      const audit =
                        nhsUtiFormData ||
                        (() => {
                          try {
                            if (
                              !selectedPatientConsultation?.consultationSummary
                            )
                              return null;
                            let parsed = JSON.parse(
                              selectedPatientConsultation.consultationSummary,
                            );
                            if (typeof parsed === "string")
                              parsed = JSON.parse(parsed);
                            return parsed;
                          } catch {
                            return null;
                          }
                        })();
                      if (!audit || !audit.patient)
                        return (
                          <PatientSummary
                            getData={getData}
                            highlightedSnomedEvidence={
                              highlightedSnomedEvidence
                            }
                            darkMode={darkMode}
                          />
                        );
                      let pathway;
                      try {
                        pathway = getPathway("uti");
                      } catch {
                        return null;
                      }
                      return (
                        <ConsultationSummary
                          audit={audit}
                          pathway={pathway}
                          isDarkMode={darkMode}
                          readOnly={isConsultationCompleted}
                          onClose={
                            isConsultationCompleted
                              ? undefined
                              : () => setShowPathwayCompletionModal(true)
                          }
                        />
                      );
                    })()
                  ) : summaryEffectiveTemplateId === nhsSoreThroatTemplateId ? (
                    (() => {
                      const audit =
                        nhsSoreThroatFormData ||
                        (() => {
                          try {
                            if (
                              !selectedPatientConsultation?.consultationSummary
                            )
                              return null;
                            let parsed = JSON.parse(
                              selectedPatientConsultation.consultationSummary,
                            );
                            if (typeof parsed === "string")
                              parsed = JSON.parse(parsed);
                            return parsed;
                          } catch {
                            return null;
                          }
                        })();
                      if (!audit || !audit.patient)
                        return (
                          <PatientSummary
                            getData={getData}
                            highlightedSnomedEvidence={
                              highlightedSnomedEvidence
                            }
                            darkMode={darkMode}
                          />
                        );
                      let pathway;
                      try {
                        pathway = getPathway("sorethroat");
                      } catch {
                        return null;
                      }
                      return (
                        <ConsultationSummary
                          audit={audit}
                          pathway={pathway}
                          isDarkMode={darkMode}
                          readOnly={isConsultationCompleted}
                          onClose={
                            isConsultationCompleted
                              ? undefined
                              : () => setShowPathwayCompletionModal(true)
                          }
                        />
                      );
                    })()
                  ) : summaryEffectiveTemplateId === nhsSoreThroatTemplateId ? (
                    (() => {
                      const audit =
                        nhsSoreThroatFormData ||
                        (() => {
                          try {
                            if (
                              !selectedPatientConsultation?.consultationSummary
                            )
                              return null;
                            let parsed = JSON.parse(
                              selectedPatientConsultation.consultationSummary,
                            );
                            if (typeof parsed === "string")
                              parsed = JSON.parse(parsed);
                            return parsed;
                          } catch {
                            return null;
                          }
                        })();
                      if (!audit || !audit.patient)
                        return (
                          <PatientSummary
                            getData={getData}
                            highlightedSnomedEvidence={
                              highlightedSnomedEvidence
                            }
                            darkMode={darkMode}
                          />
                        );
                      let pathway;
                      try {
                        pathway = getPathway("sorethroat");
                      } catch {
                        return null;
                      }
                      return (
                        <ConsultationSummary
                          audit={audit}
                          pathway={pathway}
                          isDarkMode={darkMode}
                          readOnly={isConsultationCompleted}
                          onClose={
                            isConsultationCompleted
                              ? undefined
                              : () => setShowPathwayCompletionModal(true)
                          }
                        />
                      );
                    })()
                  ) : summaryEffectiveTemplateId === nhsImpetigoTemplateId ? (
                    (() => {
                      const audit =
                        nhsImpetigoFormData ||
                        (() => {
                          try {
                            if (
                              !selectedPatientConsultation?.consultationSummary
                            )
                              return null;
                            let parsed = JSON.parse(
                              selectedPatientConsultation.consultationSummary,
                            );
                            if (typeof parsed === "string")
                              parsed = JSON.parse(parsed);
                            return parsed;
                          } catch {
                            return null;
                          }
                        })();
                      if (!audit || !audit.patient)
                        return (
                          <PatientSummary
                            getData={getData}
                            highlightedSnomedEvidence={
                              highlightedSnomedEvidence
                            }
                            darkMode={darkMode}
                          />
                        );
                      let pathway;
                      try {
                        pathway = getPathway("impetigo");
                      } catch {
                        return null;
                      }
                      return (
                        <ConsultationSummary
                          audit={audit}
                          pathway={pathway}
                          isDarkMode={darkMode}
                          readOnly={isConsultationCompleted}
                          onClose={
                            isConsultationCompleted
                              ? undefined
                              : () => setShowPathwayCompletionModal(true)
                          }
                        />
                      );
                    })()
                  ) : summaryEffectiveTemplateId ===
                    nhsInsectBitesTemplateId ? (
                    (() => {
                      const audit =
                        nhsInsectBitesFormData ||
                        (() => {
                          try {
                            if (
                              !selectedPatientConsultation?.consultationSummary
                            )
                              return null;
                            let parsed = JSON.parse(
                              selectedPatientConsultation.consultationSummary,
                            );
                            if (typeof parsed === "string")
                              parsed = JSON.parse(parsed);
                            return parsed;
                          } catch {
                            return null;
                          }
                        })();
                      if (!audit || !audit.patient)
                        return (
                          <PatientSummary
                            getData={getData}
                            highlightedSnomedEvidence={
                              highlightedSnomedEvidence
                            }
                            darkMode={darkMode}
                          />
                        );
                      let pathway;
                      try {
                        pathway = getPathway("insectbites");
                      } catch {
                        return null;
                      }
                      return (
                        <ConsultationSummary
                          audit={audit}
                          pathway={pathway}
                          isDarkMode={darkMode}
                          readOnly={isConsultationCompleted}
                          onClose={
                            isConsultationCompleted
                              ? undefined
                              : () => setShowPathwayCompletionModal(true)
                          }
                        />
                      );
                    })()
                  ) : summaryEffectiveTemplateId === nhsShinglesTemplateId ? (
                    (() => {
                      const audit =
                        nhsShinglesFormData ||
                        (() => {
                          try {
                            if (
                              !selectedPatientConsultation?.consultationSummary
                            )
                              return null;
                            let parsed = JSON.parse(
                              selectedPatientConsultation.consultationSummary,
                            );
                            if (typeof parsed === "string")
                              parsed = JSON.parse(parsed);
                            return parsed;
                          } catch {
                            return null;
                          }
                        })();
                      if (!audit || !audit.patient)
                        return (
                          <PatientSummary
                            getData={getData}
                            highlightedSnomedEvidence={
                              highlightedSnomedEvidence
                            }
                            darkMode={darkMode}
                          />
                        );
                      let pathway;
                      try {
                        pathway = getPathway("shingles");
                      } catch {
                        return null;
                      }
                      return (
                        <ConsultationSummary
                          audit={audit}
                          pathway={pathway}
                          isDarkMode={darkMode}
                          readOnly={isConsultationCompleted}
                          onClose={
                            isConsultationCompleted
                              ? undefined
                              : () => setShowPathwayCompletionModal(true)
                          }
                        />
                      );
                    })()
                  ) : summaryEffectiveTemplateId === nhsAomTemplateId ? (
                    (() => {
                      const audit =
                        nhsAomFormData ||
                        (() => {
                          try {
                            if (
                              !selectedPatientConsultation?.consultationSummary
                            )
                              return null;
                            let parsed = JSON.parse(
                              selectedPatientConsultation.consultationSummary,
                            );
                            if (typeof parsed === "string")
                              parsed = JSON.parse(parsed);
                            return parsed;
                          } catch {
                            return null;
                          }
                        })();
                      if (!audit || !audit.patient)
                        return (
                          <PatientSummary
                            getData={getData}
                            highlightedSnomedEvidence={
                              highlightedSnomedEvidence
                            }
                            darkMode={darkMode}
                          />
                        );
                      let pathway;
                      try {
                        pathway = getPathway("otitismedia");
                      } catch {
                        return null;
                      }
                      return (
                        <ConsultationSummary
                          audit={audit}
                          pathway={pathway}
                          isDarkMode={darkMode}
                          readOnly={isConsultationCompleted}
                          onClose={
                            isConsultationCompleted
                              ? undefined
                              : () => setShowPathwayCompletionModal(true)
                          }
                        />
                      );
                    })()
                  ) : summaryEffectiveTemplateId === nhsAhtWeightTemplateId ? (
                    (() => {
                      const audit =
                        nhsAhtFormData ||
                        (() => {
                          try {
                            if (
                              !selectedPatientConsultation?.consultationSummary
                            )
                              return null;
                            let parsed = JSON.parse(
                              selectedPatientConsultation.consultationSummary,
                            );
                            if (typeof parsed === "string")
                              parsed = JSON.parse(parsed);
                            return parsed;
                          } catch {
                            return null;
                          }
                        })();
                      if (!audit || !audit.patient)
                        return (
                          <PatientSummary
                            getData={getData}
                            highlightedSnomedEvidence={
                              highlightedSnomedEvidence
                            }
                            darkMode={darkMode}
                          />
                        );
                      let summaryData;
                      try {
                        summaryData = buildAhtWeightSummaryData({
                          ...audit,
                          startedAt: audit._chainStartedAt || audit.startedAt,
                        });
                      } catch (err) {
                        console.error(
                          "[AHT weight summary] could not build summary from audit:",
                          err,
                        );
                        return null;
                      }
                      return (
                        <div className="p-6 overflow-y-auto">
                          <PGDWeightManagementSummary
                            isDarkMode={darkMode}
                            data={summaryData}
                            prescriptions={[]}
                            isCompleted={isConsultationCompleted}
                            onComplete={() =>
                              setShowPathwayCompletionModal(true)
                            }
                          />
                        </div>
                      );
                    })()
                  ) : summaryEffectiveTemplateId === nhsAhtFollowUpTemplateId ||
                    summaryEffectiveTemplateId === nhsAhtSixMonthTemplateId ? (
                    (() => {
                      let formData = null;
                      try {
                        if (selectedPatientConsultation?.consultationSummary) {
                          let parsed = JSON.parse(
                            selectedPatientConsultation.consultationSummary,
                          );
                          if (typeof parsed === "string")
                            parsed = JSON.parse(parsed);
                          formData = parsed;
                        }
                      } catch {
                        formData = null;
                      }
                      if (!formData)
                        return (
                          <PatientSummary
                            getData={getData}
                            highlightedSnomedEvidence={
                              highlightedSnomedEvidence
                            }
                            darkMode={darkMode}
                          />
                        );
                      const isFollowUp =
                        formData.formType === "aht-follow-up-4wk";
                      return (
                        <div
                          className={`p-4 space-y-3 rounded-lg border ${
                            darkMode
                              ? "border-gray-700 bg-gray-800"
                              : "border-gray-200 bg-white"
                          }`}
                        >
                          <div
                            className={`px-4 py-3 rounded-lg border ${
                              darkMode
                                ? "bg-purple-900/20 border-purple-700"
                                : "bg-purple-50 border-purple-200"
                            }`}
                          >
                            <p
                              className={`font-semibold text-sm ${
                                darkMode ? "text-purple-200" : "text-purple-900"
                              }`}
                            >
                              {isFollowUp
                                ? "AHT Weight Management — 4-Week Supply Review (Completed)"
                                : "AHT Weight Management — 6-Month Independent Review (Completed)"}
                            </p>
                          </div>
                          <div className="space-y-2 text-sm">
                            {formData.decision && (
                              <p>
                                <span className="font-medium">Decision:</span>{" "}
                                {formData.decision}
                              </p>
                            )}
                            {isFollowUp && formData.medicinePrescribed && (
                              <p>
                                <span className="font-medium">Prescribed:</span>{" "}
                                {formData.medicinePrescribed}
                              </p>
                            )}
                            {formData.sigName && (
                              <p>
                                <span className="font-medium">Signed by:</span>{" "}
                                {formData.sigName} · {formData.sigDate}
                              </p>
                            )}
                          </div>
                        </div>
                      );
                    })()
                  ) : summaryEffectiveTemplateId ===
                    nhsAhtTravelHealthTemplateId ? (
                    (() => {
                      let summaryData = null;
                      try {
                        if (selectedPatientConsultation?.consultationSummary) {
                          let parsed = JSON.parse(
                            selectedPatientConsultation.consultationSummary,
                          );
                          if (typeof parsed === "string")
                            parsed = JSON.parse(parsed);
                          summaryData = parsed;
                        }
                      } catch {
                        summaryData = null;
                      }
                      if (
                        !summaryData ||
                        summaryData._type !== "travel-health-consultation"
                      )
                        return (
                          <PatientSummary
                            getData={getData}
                            highlightedSnomedEvidence={
                              highlightedSnomedEvidence
                            }
                            darkMode={darkMode}
                          />
                        );
                      return (
                        <TravelHealthConsultationSummary
                          isDarkMode={darkMode}
                          data={summaryData}
                        />
                      );
                    })()
                  ) : (
                    <PatientSummary
                      getData={getData}
                      highlightedSnomedEvidence={highlightedSnomedEvidence}
                      darkMode={darkMode}
                    />
                  ))}
              </div>
            </div>
          </>
        )}
      </motion.div>
    </motion.div>
  );
}
